import React from "react";
import ReactCountryFlag, { ReactCountryFlagProps } from "react-country-flag";
import Emoji from "react-emoji-render";

export const FlagIcon = (props: Partial<ReactCountryFlagProps> & { code: string; size?: string }) => {
  const size = props.size || "1em";

  let countryCode = props.code;
  switch (props.code) {
    case "none": {
      countryCode = "gb";
      break;
    }
    case "en": {
      countryCode = "gb";
      break;
    }
    case "da": {
      countryCode = "dk";
      break;
    }
    case "zh": {
      countryCode = "cn";
      break;
    }
    case "cs": {
      countryCode = "cz";
      break;
    }
    case "ar": {
      countryCode = "sa";
      break;
    }
    case "sv": {
      countryCode = "se";
      break;
    }
    case "sl": {
      countryCode = "si";
      break;
    }
    case "sgn": {
      return <Emoji text=":deaf_person:" />;
    }
  }
  return (
    <ReactCountryFlag {...props} style={{ width: size, height: size }} svg countryCode={countryCode.toUpperCase()} />
  );
};
